module.exports = __webpack_public_path__ + "static/media/BellWhite.aee3ab59.svg";